import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import { MdOutlineInbox } from "react-icons/md";
import axios from "axios";
import apiEndpoints from "../../apiconfig";
const TransactionsUI = () => {
  const [transactions, setTransactions] = useState([]);
 const fetchTransactions = async () => {
   try {
     const token = localStorage.getItem("token"); // your JWT
     const res = await axios.get(`${apiEndpoints.transaction}`, {
       headers: {
         Authorization: `Bearer ${token}`,
       },
     });

     if (res.data.status === "success") {
       setTransactions(res.data.transactions);
     } else {
       console.error("Error:", res.data.message);
     }
   } catch (error) {
     console.error("Error fetching transactions:", error);
   }
 };

  useEffect(() => {
    fetchTransactions();
  }, []);
  return (
    <Card sx={{ borderRadius: 3, boxShadow: 2, mb: 4 }}>
      <CardContent>
        <Typography
          variant="h6"
          fontWeight={700}
          color="#1F2937"
          sx={{ mb: 2 }}
        >
          Transaction History
        </Typography>
        {/* Table View */}
        {transactions.length > 0 ? (
          <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
            <Table>
              <TableHead sx={{ bgcolor: "#F3F4F6" }}>
                <TableRow>
                  {[
                    "S.No",
                    "Transaction ID",
                    "Customer Name",
                    "Amount",
                    "GST",
                    "Total Amount",
                    "Date & Time",
                    "Status",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      sx={{ fontWeight: 600, color: "#1F2937" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions.map((txn, idx) => (
                  <TableRow
                    key={txn.transaction_id}
                    sx={{
                      "&:hover": {
                        bgcolor: "#F9FAFB",
                        transition: "0.3s",
                      },
                    }}
                  >
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{txn.transaction_id}</TableCell>
                    <TableCell>{txn.customer_name}</TableCell>
                    <TableCell>₹ {txn.amount}</TableCell>
                    <TableCell>₹ {parseFloat(txn.gst).toFixed(2)}</TableCell>
                    <TableCell>₹ {txn.total_amount}</TableCell>
                    <TableCell>{txn.date_time}</TableCell>
                    <TableCell>
                      <Chip
                        label={txn.status}
                        sx={{
                          bgcolor:
                            txn.status === "Success"
                              ? "#D1FAE5"
                              : txn.status === "Pending"
                              ? "#FEF3C7"
                              : "#FECACA",
                          color:
                            txn.status === "Success"
                              ? "#065F46"
                              : txn.status === "Pending"
                              ? "#92400E"
                              : "#991B1B",
                          fontWeight: 600,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={6}
            color="#6B7280"
          >
            <MdOutlineInbox size={64} color="#9CA3AF" />
            <Typography mt={1}>No transactions available</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
export default TransactionsUI;




















